import { getIsWrapOrUnwrap } from "utils/tokenSelectorUtils";
import { TradeDetailsSection } from "../../components/DetailsSection/TradeDetailsSection";
import { YouPaySection } from "../../components/Modal/instance/ConfirmTrade/YouPaySection";
import { YouReceiveSection } from "../../components/Modal/instance/ConfirmTrade/YouReceiveSection";
import { ProgressBar } from "../../components/ProgressBar/ProgressBar";
import { QuoteExpiryBar } from "../../components/QuoteExpiryBar/QuoteExpiryBar";
import { Spacer } from "../../components/general/Spacer/Spacer";
import { GlobalStore } from "../../store/global/GlobalStore";
import { Amount } from "../../types/amount";
import { OrderStatus } from "../../types/orderStatus";
import { getOrderType } from "../../utils/orderTypeUtils";
import "./OrderEntry.css";
import { ReviewActionButton } from "./ReviewActionButton";
import { ReviewOrderBack } from "./ReviewOrderBack";
import { ReviewOrderHeader } from "./ReviewOrderHeader";
import { WrapActionButton } from "../Wrap/elements/WrapActionButton";

export const ReviewOrder: React.FC = () => {
  const orderStatus = GlobalStore.useState(s => s.orderStatus);
  const { networkFee, quote, wrapQuote, takerTokens, makerTokens, chain, orderType } =
    GlobalStore.useState(s => {
      return {
        networkFee: s.quote?.usdGasFee,
        quote: s.quote,
        wrapQuote: s.wrapQuote,
        takerTokens: s.takerTokens,
        makerTokens: s.makerTokens,
        address: s.address,
        chain: s.network,
        orderType: getOrderType(s),
      };
    });
  const isWrapOrUnwrap = getIsWrapOrUnwrap(
    takerTokens.map(t => t.token),
    makerTokens.map(t => t.token),
    chain
  );

  return (
    <>
      <ReviewOrderBack />
      <ReviewOrderHeader />
      <YouPaySection shouldDisplayLabel />
      <YouReceiveSection shouldDisplayLabel />
      {quote && <QuoteExpiryBar />}
      {orderStatus === OrderStatus.REVIEW && !isWrapOrUnwrap && (
        <>
          <Spacer height="22px" />
          <TradeDetailsSection networkFee={networkFee ?? Amount.ZERO} visible={true} />
        </>
      )}
      <div className={"progress-bar-container"}>
        <ProgressBar step={2} />
      </div>
      {orderType !== undefined && quote !== undefined && <ReviewActionButton />}
      {wrapQuote?.amount != null && <WrapActionButton />}
    </>
  );
};
